module.exports = __webpack_public_path__ + "img/planting_02@2x.926e991.jpg";